import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';

import {ReduxDispatch, ReduxState} from '../redux/store';

export const useAppDispatch: () => ReduxDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<ReduxState> = useSelector;
